import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IStepperPanelProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    usePointerType
} from "../../../../helpers/pointer";
import type {
    StepperItemPartContentProps
} from "../../type";
import {
    withStepperItemContext
} from "../../context";
import {
    getStepperMeasures
} from "../../stylesheet";

const StepperPanelContent: FC<StepperItemPartContentProps<IStepperPanelProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    item,
    ...props
}) => {
    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        touchTargets,
        typography,
        iconSizes,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context.customTheme);

    const pointerType = usePointerType();

    const content = children ?? (item.isCurrent ? item.step.content : null);

    const isEmpty = content === null || content === undefined || content === false;

    const measures = getStepperMeasures({
        orientation: context.orientation,
        isInSheet: context.isInSheet,
        size: context.size,
        controlPaddings,
        controlHeights,
        shapeConfigs,
        touchTargets,
        pointerType,
        typography,
        iconSizes,
        borders,
        spaces
    });

    const {
        container: containerDynamicStyle
    } = useStyles({
        isSkipped: item.status === "skipped",
        isDone: item.isDone,
        isLast: item.isLast,
        measures,
        isEmpty,
        colors,
        spaces
    });

    if(isEmpty && item.isLast) {
        return null;
    }

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {isEmpty ? null : content}
    </View>;
};
export default withStepperItemContext("Panel", StepperPanelContent);
